// @flow
import { defaultTo } from 'lodash/util'
import {
  GRID_SIZE_MD,
  GRID_SIZE_LG,
  GRID_SIZE_XL,
  GRID_SIZE_DEFAULT
} from '../../constants'
export const SITE_CONTAINER_MAX_WIDTH = 1200
export const NAVBAR_HEIGHT_MOBILE = 49
export const NAVBAR_HEIGHT_DESKTOP = 0
export const NAVBAR_HEIGHT_MOBILE_MESSAGE = 95
export const NAVBAR_HEIGHT_DESKTOP_MESSAGE = 111

const getMaxWidth = viewport => {
  switch (viewport) {
    case 'md':
      return GRID_SIZE_MD
    case 'lg':
      return GRID_SIZE_LG
    case 'xl':
      return GRID_SIZE_XL
    default:
      return GRID_SIZE_DEFAULT
  }
}

export default {
  navbarDesktop: (freeDeliveryMessage: boolean, background: string) => ({
    marginBottom: 32,
    background: defaultTo(background, 'white')
  }),
  navbarMobile: (
    freeDeliveryMessage: boolean,
    hasNoPadding: boolean,
    background: string
  ) => ({
    marginBottom: hasNoPadding ? 0 : 16,
    height: freeDeliveryMessage
      ? NAVBAR_HEIGHT_MOBILE_MESSAGE
      : NAVBAR_HEIGHT_MOBILE,
    background: defaultTo(background, 'white')
  }),
  toolbar: (color: string) => ({
    color,
    borderBottom: `1px solid ${color}`
  }),
  toolbarMobile: (color: string) => ({
    borderBottom: `1px solid ${color}`,
    minHeight: 48
  }),
  container: (viewport: string, isAtHomePage: boolean) => ({
    maxWidth: isAtHomePage ? getMaxWidth(viewport) : SITE_CONTAINER_MAX_WIDTH,
    margin: '0 auto',
    alignItems: 'center',
    padding: '0px 16px'
  })
}
